module.exports = __webpack_public_path__ + "static/gorzyce-logo.16825060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gorzyce-logo.png
// module id = 698
// module chunks = 35783957827783